var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 home-bonuses-container px-0 mb-3"})}
var staticRenderFns = []

export { render, staticRenderFns }